import styled from "styled-components";
import img from "../../assets/404-page-not-found.png";


export const MainContent = styled.img`

    
    height: 65vh;

    @media (min-width: 800px){
        width: 50%;
    }

`